import { Action, createReducer, on } from "@ngrx/store";
import { ISupplier } from "../models/suppliers.models";
import * as suppliersActions from '../store/suppliers.actions';
import { IPagination } from "src/app/shared/models/page.model";

export interface SuppliersFilterState {
  searchSupplier: string;
}

export interface SuppliersState {
    suppliers: ISupplier[];
    metadata: IPagination | null;
    suppliersFilterState: SuppliersFilterState,
    loading: boolean;
}

export const initialSuppliersState: SuppliersState = {
    suppliers: [],
    metadata: null,
    suppliersFilterState: {
      searchSupplier: ''
    },
    loading: false,
};

const featureReducer = createReducer(
  initialSuppliersState,
  on(
    suppliersActions.FetchSuppliersSuccess,
    (state, action) => ({
      ...state,
      suppliers: action.suppliers.data,
      metadata: action.suppliers.metadata
    })
  ),
  on(suppliersActions.SetSupplierLoader, (state, action) => ({
    ...state,
    loading: action.isLoading
  })),
  on(suppliersActions.AddSupplierSuccess, (state, action) => ({
    ...state,
    suppliers: [...state.suppliers, action.supplier as ISupplier],
  })),
  on(suppliersActions.SetSupplierSearch, (state, action) => ({
    ...state,
    suppliersFilterState: {
      searchSupplier: action.search,
    }
  })),
);

export function suppliersReducer(state: SuppliersState | undefined, action: Action) {
    return featureReducer(state, action);
  }
